import { useCallback } from 'react'

import { getPlacesByGeocode } from '../services/googleMapsServices'
import {
  filterByTypes,
  formatGoogleAutoCompleteResponse
} from '../utils/googleMapsUtils'

export function useCoords() {
  const getPosition = useCallback(
    async (latitude: number, longitude: number) => {
      const { isSuccess, data } = await getPlacesByGeocode({
        coordinates: {
          lat: latitude,
          lng: longitude
        }
      })

      if (!isSuccess || !data?.length) {
        return Promise.reject(new Error('No places found'))
      }

      const filter = filterByTypes({
        places: data || []
      })

      const place = filter?.length ? filter[0] : undefined

      if (!place?.placeId) {
        return Promise.reject(new Error('No places found'))
      }

      const formatted = formatGoogleAutoCompleteResponse({
        place,
        coordinates: {
          lat: latitude,
          lng: longitude
        }
      })

      return formatted
    },
    []
  )

  return {
    getPosition
  }
}
